import * as React from 'react';
export const IcSortUp = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 17H4c-.27 0-.52.11-.71.29A.99.99 0 003 18c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0010 17zm0-6H4c-.27 0-.52.11-.71.29A.99.99 0 003 12c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0010 11zm4.21 4.22l1.29-1.3v4.09c0 .27.11.52.29.71.18.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71v-4.09l1.29 1.3c.19.19.44.29.71.29.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71l-3-3a.955.955 0 00-.33-.22.995.995 0 00-.38-.08c-.13 0-.26.03-.38.08s-.23.13-.33.22l-3 3c-.09.09-.17.2-.22.33-.05.12-.08.25-.08.38s.03.26.08.38a1.004 1.004 0 00.55.55c.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22zM20 5H4c-.27 0-.52.11-.71.29A.99.99 0 003 6c0 .27.11.52.29.71.19.19.44.29.71.29h16c.27 0 .52-.11.71-.29A.99.99 0 0021 6c0-.27-.11-.52-.29-.71A.99.99 0 0020 5z'
      fill='currentColor'
    />
  </svg>
);
